<template>
  <div class="tab">
    <router-link
      to="/personal_center/enterprise/property_services/pass/table_list"
      class="tab_item"
    >物品放行</router-link>
    <router-link
      to="/personal_center/enterprise/property_services/renovation/table_list"
      class="tab_item"
    >二次装修</router-link>
    <router-link
      to="/personal_center/enterprise/property_services/air_conditioner/table_list"
      class="tab_item"
    >空调安维</router-link>
    <router-link
      to="/personal_center/enterprise/property_services/evacuate/table_list"
      class="tab_item"
    >入驻撤离</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  .tab_item {
    padding: 15px 30px;
    font-size: 14px;
    border: 1px solid #eee;
    color: #666;
  }
  .tab_item.router-link-active {
    font-weight: 600;
    color: #333;
  }
}
</style>